import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
const caretexLogo = "/caretex-logo-transparent.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact");
    contactSection?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? "bg-primary/95 backdrop-blur-lg border-b border-white/10 py-2"
          : "bg-transparent py-4"
      }`}
    >
      <div className="container mx-auto px-6">
        <div className="flex items-center justify-between">
          {/* Logo - Enlarged */}
          <a href="/" className="flex items-center">
            <img 
              src={caretexLogo} 
              alt="CARETEX" 
              width={96}
              height={96}
              fetchPriority="low"
              className="h-16 md:h-20 lg:h-24 w-auto object-contain"
            />
          </a>

          {/* CTA Button */}
          <Button 
            onClick={scrollToContact}
            className="bg-accent hover:bg-accent/90 text-accent-foreground font-bold px-6 py-3 text-base md:text-lg glow-accent transition-all duration-300 hover:scale-105"
          >
            השאירו פרטים
          </Button>
        </div>
      </div>
    </header>
  );
};

export default Header;
